import React from 'react'
import { lu } from '../../data/reportData';
import { TAB, H1, TXC, TCH } from "../../styles/urar-styles";
import { IMAGE_MAP, IMAGE_SC, EXHIBITS, TABLE, TB_SCA_SUB_H1, TB_SCA_H2 } from "../../styles/urar-styles";

export default function SALES_COMPARISON() {
	return (
		<>
		<SALES_COMPARISON_PAGES />

		<H1 title="Reconciliation of Sales Comparison Approach" />
		<TXC comment={lu("22.018")} />

		{ global.ptr.valuationAnalysis.analyzedProperties &&
		<>
			<H1 title="Additional Properties Analyzed Not Used" />
			<TABLE titles={["#","Property Address","Sale Date","Status","Reason Not Used","Comment"]} widths={[38,220,108,168,168,378]} values={lu("22.019")} />
		</>
		}

		<H1 title="Sales Comparison Map" />
		<IMAGE_MAP category="SalesComparableMap"  />

		<EXHIBITS title="Sales Comparison Approach Exhibits" values={lu("22.099")} />
		</>
	)
}

function SALES_COMPARISON_PAGES() {
	let numComps = global.ptr.compCount;
	let pages = [];
	for (let i = 0; i < numComps; i += 3)
			pages.push(Math.floor(i / 3));

	return (
		<>
		{
			pages.map((p, i) => {
				return (
					<SALES_COMPARISON_APPROACH key={i} page={p} numComps={numComps} />
				)
			})
		}
		</>
	)
}

function SALES_COMPARISON_APPROACH({page, numComps}) {
	let titles = [];
	titles.push("");
	titles.push("Subject Property");
	let widths = [];
	widths.push(216);
	widths.push(216);

	let cn = (page * 3) + 1; // starting comp number
	for (let ix = cn; ix < cn+3 && ix <= numComps; ++ix) {
		titles.push("Comparable #" + ix.toString());
		widths.push(216);
	}

	let end = (page * 3) + 2;
	if (end > numComps) end = numComps;
	let width = 216 * (widths.length);

	let continued = (page > 0);

	return (
		<>
			<TAB title="Sales Comparison Approach" continued={continued}/>
			<TCH titles={titles} widths={widths} centered />

			<TB_SCA_SUB_H1 width={width} title="General Information" notop />
			<LIST_SINGLE_ROW page={page} values={lu("22.001.1")}  />
			<LIST_IMAGE_ROW page={page} values={lu("22.001.2")} />
			<LIST_FIELDS page={page} values={lu("22.001")} />
			{ global.ptr.bInProject &&
			<>
				<TB_SCA_SUB_H1 width={width} title="Project Information" />
				<LIST_FIELDS page={page} values={lu("22.002")} />
			</>
			}
			<TB_SCA_SUB_H1 width={width} title="Site" />
			<LIST_FIELDS page={page} values={lu("22.003")} />
			{ global.ptr.valuationAnalysis.GetPrivateWaterAccess() &&
			<>
				<TB_SCA_SUB_H1 width={width} title="Water Frontage with Private Access" />
				<LIST_FIELDS page={page} values={lu("22.004")} />
			</>
			}
			<TB_SCA_SUB_H1 width={width} title="Dwelling(s)" />
			<LIST_FIELDS page={page} values={lu("22.005")} />

			{ global.ptr.subProp.energyEfficiencyAndGreen.EnergyExists() &&
			<>
				<TB_SCA_SUB_H1 width={width} title="Energy Efficient and Green Features" />
				<LIST_FIELDS page={page} values={lu("22.006")} />
			</>
			}

			<TB_SCA_SUB_H1 width={width} title="Unit(s)" />
			<UNITS page={page} values={lu("22.007")} />

			<TB_SCA_SUB_H1 width={width} title="Quality and Condition (Ratings: 1-6, 1 is highest)" />
			{ global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator &&
			<>
				<TB_SCA_H2 width={width} title="Exterior Quality and Condition" />
				<UNITS page={page} values={lu("22.009")} />
				{/* <LIST_FIELDS page={page} values={lu("22.009")} /> */}
			</>
			}
			<TB_SCA_H2 width={width} title="Interior Quality and Condition" />
			<UNITS page={page} values={lu("22.010")} />

			{ global.ptr.subProp.HasADU() &&
			<>
				<TB_SCA_H2 width={width} title="ADU Interior Quality and Condition" />
				{
					lu("22.011").map((adu, i) => {
						return (
							<LIST_FIELDS page={page} key={i} values={adu} />
						)
					})
				}
			</>
			}

			<TB_SCA_SUB_H1 width={width} title="Overall Quality and Condition" />
			<LIST_FIELDS page={page} values={lu("22.012")} />

			<TB_SCA_SUB_H1 width={width} title="Property Amenities" />
			<LIST_FIELDS page={page} values={lu("22.013")} />

			<TB_SCA_SUB_H1 width={width} title="Vehicle Storage" />
			<LIST_FIELDS page={page} values={lu("22.014")} />

			{ lu("22.015.0") &&
			<>
				<TB_SCA_SUB_H1 width={width} title="Outbuilding (ADU and vehicle storage are not included in Finished Area, Unfinished Area, or room counts" />
				<LIST_FIELDS page={page} values={lu("22.015")} />
			</>
			}

			<TB_SCA_SUB_H1 width={width} title="Summary" />
			<LIST_FIELDS page={page} values={lu("22.016")} />
			<TB_SCA_H2 width={width} title="Indicated Value by Sales Comparison Approach" />
			<div style={{width: `${width}px`}} className='flex flex-row border-t-[1px] border-gray-500' >
				<div className='tbml-216'>Indicated Value</div>
				<div className='tbml-216-l'>{lu("22.017")}</div>
				<div className='tbml-216-l-filler w-full bg-gray-200'></div>
			</div>
		</>
	)
}

function UNITS({page, values}) {
	return (
		<>
		{
			values.map((u, ui) => {
				//console.log(ui, u);
				return (
					<React.Fragment key={ui}>
						{ ui > 0 &&
							<div className='hr-2 ' />
						}
						<LIST_FIELDS page={page} values={u} />
					</React.Fragment>
				)
			})
		}
		</>
	)
}

export function LIST_FIELDS({page, values}) {
	if (!values) return undefined;
	//console.log("lf", values);
	return (
		<div>
			<div className={"flex flex-col"}>
			{
				values.map((v, vi) => {
					return (
						<LIST_ROW key={vi} page={page} values={v} />
					)
				})
			}
			</div>
		</div>
		)
}


function LIST_ROW({page, values}) {
	if (!values) return undefined;
	// this lists the individual row
	// value[0] is always a string and indicates if the row should be bold

	let left = values.slice(0, 2);
	let start = (page*3) + 2;
	let right = values.slice(start, start+3);
	let vals = [...left, ...right];
	//console.log("LF", page, left, right, values, vals);

	if (vals.length > 0) {
		let v0 = vals[0];
		if (v0 === undefined) return;
		if (v0.length === 0) return;
		if (typeof v0 !== "string") {
			console.log("v0 is not a string: ", typeof v0, v0);
			console.log(values);
			return;
		}
	}
	try {
		return (
			<div className='flex flex-row ' >
			{
			vals.map((rx, ri) => {
				if (ri === 0 || ri < 5) {
					return (
						<React.Fragment key={ri}>
						{(typeof rx === "object") &&
							<LIST_O value={rx} />
						}
						{(typeof rx !== "object") &&
							<LIST_S value={rx} ix={ri} />
						}
						</React.Fragment>
					)
				}
			})
			}
			</div>
		)
	} catch(err) {
		console.log("LIST_ROW: ", err);
		console.log(values);
	}
}

function LIST_S({value, ix}) {
	var cn = (ix === 0) ? "tbml-216" : "tbml-216-l";
	if (value === "GRAY") {
		value = "";
		cn += " bg-gray-200";
	} else if (value.length > 0 && value.charAt(0) === "!") {
		cn += " mpb";
		value = value.substring(1);
	}
	return (
		<div className={cn} >
			{value}
		</div>
	)
}
			
function LIST_O({value, bold}) {
	try {
	return (
		<>
		{
			value.map((rx, ri) => {
				var cn0 = (ri === 0) ? "tbml-136-l" : "tbml-80-l";
				if (rx === "GRAY") {
					rx = "";
					cn0 += " bg-gray-200";
				} 
				if (rx.length > 0 && rx.charAt(0) === "!") {
					cn0 += " mpb";
					rx = rx.substring(1);
				}
				return (
					<div key={100+ri} className={cn0}  >
						{rx}
					</div>
				)
			})
		}
		</>
	)
	} catch(err) {
		console.log("LIST_O: ", err);
		console.log(value);
		throw new Error(err);
	}
}

export function LIST_SINGLE_ROW({page, values}) {
	if (!values) return undefined;
	// this lists the individual row
	// value[0] is always a string and indicates if the row should be bold

	let left = values.slice(0, 2);
	let start = (page*3) + 2;
	let right = values.slice(start, start+3);
	let vals = [...left, ...right];
	//console.log("LF", page, left, right, values, vals);

	var bold = false;
	if (vals.length > 0) {
		let v0 = vals[0];
		if (v0 === undefined) return undefined

		//console.log("v0: ", v0, typeof v0);
		if (v0.charAt(0) === "!") {
			v0 = v0.substring(1);
			vals[0] = v0;
			bold = true;
		} 
	}
	try {
		return (
			<div className='flex flex-row ' >
			{
			vals.map((val, vi) => {
				var cn = (vi === 0) ? "tbnb-216" : "tbnb-216-l";
				if (vi === 0 || vi < 5) {
					return (
						<div key={vi} className={cn} >
							{val}
						</div>
						)
				}
			})
			}
			</div>
		)
	} catch(err) {
		console.log("LIST_SINGLE_ROW: ", err);
		console.log(values);
	}
}

export function LIST_IMAGE_ROW({page, values}) {
	if (!values) return undefined;
	// this lists the individual row
	// value[0] is always a string and indicates if the row should be bold

	let left = values.slice(0, 2);
	let start = (page*3) + 2;
	let right = values.slice(start, start+3);
	let vals = [...left, ...right];
	//console.log("LIM", page, left, right, values, vals);

	try {
		return (
			<div className='flex flex-row ' >
			{
			vals.map((val, vi) => {
				var cn = (vi === 0) ? "tbml-216" : "tbml-216-l";
				if (vi === 0 || vi < 5) {
					return (
						<div key={vi} className={"p-1 " + cn} >
							{ (vi > 0) &&
								<IMAGE_SC key={vi} image={val} />
							}
						</div>

						)
				}
			})
			}
			</div>
		)
	} catch(err) {
		console.log("LIST_SINGLE_ROW: ", err);
		console.log(values);
	}
}

